<div class="banner">
  <div class="banner-container">
    <div class="banner-title">
      <span class="body-m-bold text-default"> {{
          subTitle ?
            (title().length > 39 ? (title() | slice:0:39) + '…' : title()) :
            (title().length > 120 ? (title() | slice:0:120) + '…' : title())
        }}</span>
      @if (subTitle) {
        <span class="body-m text-alt">{{ subTitle.length > 80 ? (subTitle | slice:0:80) + '…' : subTitle }}</span>
      }
    </div>
    <div class="banner-action">
      @if (btnUrl()) {
        <app-button
          type="primary-white"
          size="medium"
          class="banner-button-desktop"
          [iconPosition]="'left'"
          svgIcon="{{btnIcon()}}"
          (click)="openUrl()"
          [text]="btnText()"></app-button>
      }
      @if (closeButton()) {
        <app-button
          type="tertiary-black"
          size="medium"
          [buttonClass]="'text-default'"
          (click)="closeBanner()"
          icon="close"></app-button>
      }
    </div>
  </div>
  @if (btnUrl()) {
    <div class="banner-button-mobile">
      <app-button
        type="primary-white"
        size="medium"
        [iconPosition]="'left'"
        svgIcon="{{btnIcon()}}"
        width="full"
        (click)="openUrl()"
        [text]="btnText()"></app-button>
    </div>
  }
</div>